import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  private secretKey = 'company'; // À garder confidentielle

  encrypt(data: any): string {
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
  }

  decrypt(data: string): any {
    const bytes = CryptoJS.AES.decrypt(data, this.secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  /**
   * Crypte un objet JSON
   * @param obj - L'objet à crypter
   * @returns L'objet crypté en base64
   */
  encryptObject(obj: any): string {
    try {
      const jsonString = JSON.stringify(obj);
      return this.encrypt(jsonString);
    } catch (error) {
      console.error('Erreur lors du cryptage de l\'objet:', error);
      return '';
    }
  }

  /**
   * Décrypte un objet JSON crypté
   * @param encryptedObj - L'objet crypté en base64
   * @returns L'objet décrypté
   */
  decryptObject(encryptedObj: string): any {
    try {
      const decryptedString = this.decrypt(encryptedObj);
      return JSON.parse(decryptedString);
    } catch (error) {
      console.error('Erreur lors du décryptage de l\'objet:', error);
      return {};
    }
  }
}
